import React from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import { MEAL_CATEGORIES } from "./useFilterCardData";

export const MealFilters = ({
  hasMeals,
  mealCategoryCounts,
  mealCodeCounts,
  totalMeals,
  selectedMeals,
  onMealToggle,
}) => {
  if (!hasMeals) return null;

  return (
    <>
      <Typography variant="body2" sx={{ mt: 0.75, mb: 0.25, fontWeight: "bold" }}>
        Meals
      </Typography>
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              name="All"
              checked={(selectedMeals || []).includes("All")}
              onChange={onMealToggle}
            />
          }
          label={
            <span style={{ display: "flex", alignItems: "center" }}>
              <Typography variant="body2" sx={{ mr: 0.5, fontWeight: "bold" }}>
                All
              </Typography>
              <Typography component="span" variant="caption">
                ({totalMeals})
              </Typography>
            </span>
          }
        />
        <Box sx={{ ml: 2, display: "flex", flexWrap: "wrap", columnGap: 0.5 }}>
          {MEAL_CATEGORIES.map((category) => {
            const count = mealCategoryCounts[category] || 0;
            if (count === 0) return null;
            return (
              <FormControlLabel
                key={category}
                sx={{ mr: 0.5, ml: 0 }}
                control={
                  <Checkbox
                    name={category}
                    checked={
                      (selectedMeals || []).includes(category) &&
                      !(selectedMeals || []).includes("All")
                    }
                    onChange={onMealToggle}
                  />
                }
                label={
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <Typography variant="body2" sx={{ mr: 0.5 }}>
                      {category}
                    </Typography>
                    <Typography component="span" variant="caption">
                      ({count})
                    </Typography>
                  </span>
                }
              />
            );
          })}
        </Box>
      </FormGroup>

      {Object.keys(mealCodeCounts).length > 0 && (
        <Box sx={{ mt: 0.5, ml: 2 }}>
          <Typography variant="caption" sx={{ fontWeight: "bold", mb: 0.25, display: "block" }}>
            Meal Code Summary:
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {Object.entries(mealCodeCounts)
              .sort(([mealCodeA], [mealCodeB]) =>
                mealCodeA.localeCompare(mealCodeB)
              )
              .map(([mealCode, count]) => (
                <Typography
                  key={mealCode}
                  variant="caption"
                  sx={{
                    backgroundColor: "#f0f0f0",
                    padding: "2px 6px",
                    borderRadius: "4px",
                  }}
                >
                  {mealCode}: {count}
                </Typography>
              ))}
          </Box>
        </Box>
      )}
    </>
  );
};
